"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ManagementActions = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const zustandStore_1 = require("../../zustandStore");
const commonComponents_1 = require("./commonComponents");
const ManagementActions = () => {
    const { setIsCookieCutterOpen, setShowManageCookies, saveConsent } = (0, zustandStore_1.useZustand)(state => ({ ...state }));
    const handleSave = () => {
        saveConsent();
        setShowManageCookies(false);
        setIsCookieCutterOpen(false);
    };
    return ((0, jsx_runtime_1.jsx)(commonComponents_1.DialogActionsButton, { variant: "outlined", color: "primary", onClick: handleSave, style: { justifyContent: 'center' }, "data-testid": "save-cookies-settings", children: "Save cookie settings" }));
};
exports.ManagementActions = ManagementActions;
